// extracted by mini-css-extract-plugin
module.exports = {"inputTag":"TagsInput-module__inputTag___3VTc4","tagsList":"TagsInput-module__tagsList___2oayJ","tagsListInputWrapper":"TagsInput-module__tagsListInputWrapper___1GDFP"};